import React, { useState } from "react";
import "./PointOfContactDropdown.css";
import Search from "../../../../../Icons/Search";
import Close from "../../../../../Icons/Close";

const selectedInputDisplayText = (poc) => {
  const displayText = poc.address ? `${poc.address}, ${poc.name}`  : poc.name;

  return displayText;
};

const PointOfContactDropdown = ({
  allPointOfContacts,
  setPointOfContactValue,
  locationPlaceholder,
  noLocationLabel,
  preselectedLocation
}) => {
  const emptyPointOfContact = {name: "", address:"", value: ""};

  const [selectedPointOfContact, setSelectedPointOfContact] = useState(emptyPointOfContact);
  const [filterText, setFilterText] = useState("");
  const [resultsVisibility, setResultsVisibility] = useState(false);
  const searchInput = React.createRef();
  const searchDiv = React.createRef();

  React.useEffect(() => {
    if(preselectedLocation) {
      setSelectedPointOfContact(preselectedLocation);
      setPointOfContactValue(preselectedLocation.value);
      searchInput.current.disabled = true;
      searchDiv.current.classList.add("pocd-disabled-input");
    }

    searchInput.current.value = selectedInputDisplayText(selectedPointOfContact);
    searchInput.current.title = selectedInputDisplayText(selectedPointOfContact);
    setFilterText(selectedInputDisplayText(selectedPointOfContact));
  }, [preselectedLocation]);

  React.useEffect(() => {
    searchInput.current.value = selectedInputDisplayText(selectedPointOfContact);
    searchInput.current.title = selectedInputDisplayText(selectedPointOfContact);
    setFilterText(selectedInputDisplayText(selectedPointOfContact));
  }, [selectedPointOfContact]);

  const onSelect = (pointOfContact) => {
    setSelectedPointOfContact(pointOfContact);
    setPointOfContactValue(pointOfContact.value);

    setFilterText(selectedInputDisplayText(selectedPointOfContact));
    searchInput.current.disabled = true;
    searchDiv.current.classList.add("pocd-disabled-input");
  };

  const onClear = () => {
    setSelectedPointOfContact(emptyPointOfContact);
    setPointOfContactValue("");
    setFilterText("");
    searchInput.current.disabled = false;
    searchDiv.current.classList.remove("pocd-disabled-input");
  };

  const onFocus = () => {
    setResultsVisibility(true);
  };

  const onBlur = () => {
    setResultsVisibility(false);
  };

  const onKeyUp = (event) => {
    const inputText = event.target.value;

    setFilterText(inputText);
  };

  const filterOptions = (option) => {
    return selectedInputDisplayText(option)
      .toUpperCase()
      .includes(filterText.toUpperCase());
  };

  return (
    <div className={"pocd-point-of-contact-selections"}>
      <div className={"pocd-search-box"}>
        <div className={"pocd-search-input-container"} ref={searchDiv}>
          <div className="search-icon">
            <Search />
          </div>
          <input
            className={"pocd-search-input"}
            ref={searchInput}
            type="text"
            autoComplete="off"
            placeholder={locationPlaceholder}
            onFocus={() => onFocus()}
            onBlur={() => onBlur()}
            onKeyUp={(e) => onKeyUp(e)}
            id={"poc-dropdown"}
          />

          {(JSON.stringify(selectedPointOfContact) !== JSON.stringify(emptyPointOfContact)) &&
            <div className={"pocd-clear-search"}>
              <Close className={"close-icon pocd-close-icon"} onClick={() => onClear()} />
            </div>
          }
        </div>
      </div>
      <ul className={"pocd-search-results"} style={{opacity: resultsVisibility ? 1 : 0, visibility: resultsVisibility ? "visible": "hidden"}}>
        { !allPointOfContacts.some(filterOptions) && <div className={"pocd-no-results"}>{noLocationLabel}</div>}
        { allPointOfContacts.map((option) =>
          <li className={"pocd-option"} key={option.value} onClick={() => onSelect(option)} style={{display: filterOptions(option) ? "" : "none"}}>
            <div className={"pocd-name"}>{option.name}</div>
            <div className={"pocd-address"}>{option.address}</div>
          </li>
        )}
      </ul>
    </div>
  );
};

export default PointOfContactDropdown;
